import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent, ImportButton, DownloadButton
} from "@comps/components";
import { makeRequest, makeRequestStateless, handleDownloadFile } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { message, Popconfirm, Tooltip, DatePicker, Form, Button, Switch } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { applyIncentiveReq, deleteDataReq, deleteTargetIncentiveConfigReq, getAllDataReq, getFilterReq, getTargetIncetiveConfigReq } from "./requests";
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import { UserOutlined } from "@ant-design/icons";
import { checkPermissions } from '@comps/commonFunctions';
import { CalculateOutlined } from "@mui/icons-material";

import moment from "moment";
import { getDatesFilters } from "../../common/commonFilterFields";
import { InputText } from "../../../wrappers/components";
import { updateDataReq } from "./requests";
import ImportSample from "../../common/ImportSample";
import { downloadSampleReq } from "../../common/requests";
import CreateCaseSheet from "./components/CreateCaseSheet";
import CaseSummary from "./components/CaseSummary";
import { convertTimeTotz } from "../../../wrappers/commonFunctions";

const { RangePicker } = DatePicker;
const langKey = Const["caseSheet"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["caseSheet"].route
      }
    ]
  }
}

const IndexCaseSheet = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [fromdate, setFrom] = useState(dayjs().startOf('month'));
  const [todate, setTo] = useState(dayjs().endOf('month'));
  const [allData, setAllData] = useState({});
  const [targetsConfig, setTargetConfig] = useState({});
  const [filters, setFilters] = useState(`from_|${fromdate.format('YYYY-MM-DD')};to_|${todate.format('YYYY-MM-DD')};`);
  //start pagination states
  const [summaryComponent, setSummaryComponent] = useState(null);
  const [currentPage, setCurrentPage] = useState(1)

  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const AttendanceLegends = (attendance) => {
    let html = [];
    if (!attendance) {
      html.push(<span key="day-off" className="badge badge-single bg-day-off">DO</span>);
      return <>{ html }</>;
    }
    const canShowShortDuration = attendance.is_short_duration
      && !attendance.is_absent
      && !attendance.is_missing
      && !attendance.is_late_arrival
      && !attendance.is_early_left
      && !attendance.is_full_leave
      && !attendance.is_full_official_duty
      && !attendance.is_travel
      && !attendance.is_holiday;

    if (attendance.is_day_off && !attendance.is_holiday && !attendance.rest_day_id) {
      html.push(<span key="day-off" className="badge badge-single bg-day-off">DO</span>);
      return <>{ html }</>;
    }

    if (attendance.rest_day_id) {
      html.push(<span key="rest-day" className="badge badge-single bg-default-time-slot">R</span>);
    }

    if (attendance.is_holiday && !attendance.rest_day_id) {
      html.push(<span key="holiday" className="badge badge-single bg-tr-black dker">H</span>);
    }

    if (attendance.is_present) {
      html.push(<span key="present" className="badge badge-single bg-success">P</span>);
      if (canShowShortDuration) {
        html.push(<span key="short-duration" >S</span>);
      }
    } else if (attendance.is_missing) {
      html.push(<span key="missing" className="badge badge-single bg-danger">M</span>);
    } else if (attendance.is_absent && !attendance.is_holiday && !attendance.rest_day_id) {
      html.push(<span key="absent" className="badge badge-single bg-error dker">A</span>);
    }

    if (attendance.is_relaxation) {
      html.push(<span key="relaxation" className="badge badge-single bg-informed-late">R</span>);
    }

    if ((attendance.is_short_official_duty || attendance.is_full_official_duty)) {
      html.push(<span key="official-duty" className="badge badge-single bg-darkgray">OD</span>);
    }

    if ((attendance.is_short_leave || attendance.is_full_leave)) {
      html.push(<span key="leave" className="badge badge-single bg-greensea dker">L</span>);
    }

    if (attendance.is_travel) {
      html.push(<span key="travel" className="badge badge-single bg-info">T</span>);
    }

    return <>{ html }</>;
  };

  const columns = [
    {
      key: 'date',
      title: trans(`${langKey}.date`),
      render: (record) => {
        return (
          <div className="d-flex flex-column">
            <p>{ dayjs(record.date).format('dd, MMMM D, YYYY') }</p>
            <div style={ { float: 'left' } }>{ AttendanceLegends(record.attendance) }</div>
          </div>
        )
      }
    },
    {
      key: 'employee',
      title: "Employee",
      dataIndex: 'employee_name'
    },
    {
      key: 'target',
      title: "Target Title",
      dataIndex: 'target_incentive_name'
    },

    // {
    //   key: 'assigned_target',
    //   title: "Assigned Target",
    //   dataIndex: 'assigned_target'
    // },
    {
      key: 'achieved_target',
      title: "Achieved Target",
      render: (record) => {
        return (
          <InputText
            defaultValue={ record.achieved_target }
            type="number"
            onWheel={ (e) => e.target.blur() }
            style={ { width: '100px' } }
            onChange={ (e) => onChangeRecord(record, 'achieved_target', e.target.value) }
            disabled={ false }
          />
        )
      }
    },
    {
      key: 'case_price',
      title: "Price",
      dataIndex: 'case_price',
    },
    {
      key: 'no_more_cases_available',
      title: "No More Available",
      render: (record) => {
        return (
          <Switch
            defaultChecked={ record.no_more_cases_available }
            onChange={ (e) => onChangeRecord(record, 'no_more_cases_available', e) }
            disabled={ false }
          />
        )
      }
    },
    {
      key: 'QA Names',
      title: "QA Names",
      render: (record) => {
        return (
          <>
            <ul>
              { record.qa_data && Object.values(record.qa_data).map((name, index) => (
                <li key={ index }>{ name }</li>
              )) }
            </ul>
          </>
        )
      }
    },
    {
      key: 'is_manager_approved',
      title: "QA Approval",
      render: (record) => {
        let value = "";

        if (record.approved_by_qa) {
          value = (
            <>
              <div>By { record.approved_by_qa }</div>
              { record.qa_approved_at && (
                <div className="text-primary">
                  at { convertTimeTotz(record.qa_approved_at).format('ddd MMM D, YYYY, hh:mm A') }
                </div>
              ) }
            </>
          );
        }
        return (
          <>
            <p>{ value }</p>
            <Switch
              defaultChecked={ record.is_manager_approved }
              onChange={ (e) => approveByManager(record, 'is_manager_approved', e) }
              disabled={ false }
            />
          </>
        )
      }
    },
    {
      key: 'is_final_manager_approved',
      title: "Shift Incharge Approval",
      render: (record) => {
        let value = null;
        const shiftInchargeNames = record.shift_incharge_data ? Object.values(record.shift_incharge_data) : [];
        if (record.is_final_manager_approved && record.final_manager_name) {
          value = (
            <>
              <div>By { record.final_manager_name }</div>
              { record.final_manager_approved_at && (
                <div className="text-primary">
                  at { convertTimeTotz(record.final_manager_approved_at).format('ddd MMM D, YYYY, hh:mm A') }
                </div>
              ) }
            </>
          );
        } else if (shiftInchargeNames.length > 0) {
          value = (
            <>
              <div>{ shiftInchargeNames.join(', ') }</div>
            </>
          );
        }
        return (
          <>
            <p>{ value }</p>
            <Switch
              defaultChecked={ record.is_final_manager_approved }
              onChange={ (e) => approveByFinalManager(record, 'is_final_manager_approved', e) }
              disabled={ false }
            />
          </>
        )
      }
    },
    {
      key: 'status',
      title: "Status",

      render: (record) => {
        return <span className={ record.approval_status === "Completed" ? "badge bg-success" : 'badge bg-warning' }>{ record.approval_status }</span>;
      }
    },
    // {
    //   key: 'actions',
    //   title: "Actions",
    //   render: (record) => (
    //     <ActionComponent
    //       each={ record } modkey={ props.modkey }
    //       onEdit={ onEdit }
    //     //onView={ onView }
    //     //onDelete={ onDelete }
    //     />
    //   )
    // },
  ];

  const onChangeRecord = (record, key, value) => {
    const payload = { id: record.id, [key]: Number(value) };
    updateRecord(payload);
  }

  const approveByManager = (record, key, value) => {
    const payload = { id: record.id, approval_by_qa: true };
    payload[key] = value;
    //payload.status = value ? "QA Approved" : "pending";
    updateRecord(payload);
  }
  const approveByFinalManager = (record, key, value) => {
    const payload = { id: record.id, approval_by_final_manager: true };
    payload[key] = value;
    payload.status = value ? "completed" : "pending";

    updateRecord(payload);
  }

  const updateRecord = (payload) => {
    makeRequest(setLoader, updateDataReq, payload, onUpdated, onError);
  }

  const onUpdated = (data, res) => {
    //message.success("Updated");
  }
  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);
  const getAllData = () => {
    setDataSource([]);
    setSummaryComponent(null)
    const payload = {
      page: currentPage,
      filters: filters
    }
    setChildComponent(null)
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
  };
  const onSuccess = (data, response) => {
    setSummaryComponent(<CaseSummary caseSummary={ data.summary } />)
    setTargetConfig(data.targets)
    setDataSource(data.data)
    setFrom(dayjs(response.message.from));
    setTo(dayjs(response.message.to));

    message.info("Data Fetched Successfully");
  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onEdit = (record) => {
    //setChildComponent(<UpdateTargetIncentiveConfiguration onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ false } />);
  };

  const onView = (record) => {
    //setChildComponent(<UpdateTargetIncentiveConfiguration onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ true } />);
  };

  const onViewIncentiveEmployments = (record) => {
    // setChildComponent(<ViewIncentiveEmployees onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ true } />);
  };

  const onApplyIncentive = (record) => {
    const payload = {
      incentive: record
    }
    //makeRequest(setLoader, applyIncentiveReq, payload, getAllData, onError);
  };

  const onDelete = (record) => {
    const payload = {
      filters: `employee_|${record.employment_id}`, id: record.id
    }
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    message.success("Record Deleted")
    getAllData();
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateCaseSheet onCompleted={ onCompleted } authUser={ authUser } allData={ allData } onSuccess={ onSuccess } targets={ targetsConfig } />);
  };

  const onCompleted = (data) => {

    if (data) {
      getAllData()
    }

    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------
  //download sample log
  const onDownloadSample = () => {
    makeRequestStateless(downloadSampleReq, 'case-sheets/download-sample', onSuccessDownloadSample, onSuccessDownloadSample);
  }
  const onSuccessDownloadSample = (res, err) => {
    if (res.code === undefined) {
      // Extract file extension
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `case_sheet.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }

  //change date
  const onSelectDateRange = (value, dates) => {
    setFrom(value[0]);
    setTo(value[1]);
    let payload = `from_|${fromdate.format('YYYY-MM-DD')};to_|${todate.format('YYYY-MM-DD')};`;
    if (dates) {
      payload = `from_|${dates[0]};to_|${dates[1]};`;
      setFilters(payload);
    }
  }

  return (
    <>

      { childComponent }
      <BodyComponent>

        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>

          {/* <RefreshButton onClick={ getAllData } />
          
           */ }

          {/* <div style={ { marginRight: '250px', marginLeft: '0px' } }>
            <RangePicker
              defaultValue={ [dayjs(fromdate, 'DD-MM-YYYY'), dayjs(todate, 'DD-MM-YYYY')] }
              showTime={ false }
              format="DD-MM-YYYY"
              onChange={ (value, dateString) => onSelectDateRange(value, dateString) }
            // onChange={ onSelectDateRange }
            />
          </div> */}
          <CreateButton onClick={ onCreate } />
          <RefreshButton onClick={ getAllData } />

          <DownloadButton onClick={ onDownloadSample } />
          <ImportButton onClick={ () => setChildComponent(<ImportSample onSuccess={ getAllData } api="case-sheets/import" module="case sheet" onCompleted={ () => setChildComponent(null) } />) } />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        { summaryComponent }
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      {/* <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } /> */ }
    </>
  );
};

export default IndexCaseSheet;
const filterArray = [
  {
    type: "date",
    placeholder: "From",
    key: "from",
    required: true
  },
  {
    type: "date",
    placeholder: "To",
    key: "to",
    required: true
  },
  {
    type: "select",
    placeholder: 'Employee',
    key: "employee",
    data_key: "supporting_data.employments",
    required: true,
    employeeType: 'all',
    subordinates: false,
    resource_type: 'employment'
  }
];
const filterFields = filterArray
